import type { RollDataPoint } from "./RollDistributionGraph.js";
import { RollDistributionGraph } from "./RollDistributionGraph.js";
import { DARK_COLOUR } from "./analysisConstants.js";
import { rollNames, rollPluralNames } from "./GameRollDistribution.js";
import type { APIUserStats } from "@rosette/ts/src/business/api/api_schema.js";
import { DiceType } from "@rosette/ts/src/royalur/model/dice/DiceType.js";


interface UserRollDistributionProps {
    stats: APIUserStats;
}


export function UserRollDistribution({ stats }: UserRollDistributionProps) {
    const rollProbs = DiceType.FOUR_BINARY.createDice().getRollProbabilities();
    const rollCounts = [
        stats.roll_4d2_0_count,
        stats.roll_4d2_1_count,
        stats.roll_4d2_2_count,
        stats.roll_4d2_3_count,
        stats.roll_4d2_4_count,
    ];
    let totalCount = 0;
    for (const count of rollCounts) {
        totalCount += count;
    }

    // Format data for graping.
    const data: RollDataPoint[] = [];
    for (let roll = 0; roll < rollProbs.length; ++roll) {
        const count = rollCounts[roll];
        data.push({ roll, default: (totalCount > 0 ? count / totalCount : 0) });
    }

    return (
        <RollDistributionGraph
            graphClassName="shadow-md"
            rollProbs={rollProbs}
            data={data}
            colours={{ default: DARK_COLOUR }}
            renderTooltip={({ roll }) => {
                const count = rollCounts[roll];
                const ratio = (totalCount > 0 ? count / totalCount : 0);
                const rollName = (count !== 1 ? rollPluralNames : rollNames)[roll];
                return (
                    <>
                        <div className="p-1">
                            <div className="block pb-2">
                                <span className="font-bold">
                                    {`Rolled ${count} ${rollName}`}
                                </span>
                            </div>
                            <div className="block">
                                <span>
                                    {`(${(100 * ratio).toFixed(0)}% of rolls)`}
                                </span>
                            </div>
                        </div>
                    </>
                );
            }} />
    );
}
